import { render, staticRenderFns } from "./create.vue?vue&type=template&id=e4b1fa8a"
import script from "./create.js?vue&type=script&lang=js&external"
export * from "./create.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports